import { StockPersonalENTITY } from 'sigo-entities'
import { useEffect } from "react"
import { useStockPersonalEquiposRepository } from '../../../shared/Infraestructure/hooks'
import { AdapterGenerico } from '../../../shared/Infraestructure/AdapterGenerico'
import { ViewLoading } from '../../../shared/Components/ViewLoading'
import { ViewError } from '../../../shared/Components/ViewError'

interface IProps {
    item: StockPersonalENTITY
}

export function Series(props: IProps) {
    const { item } = props
    const {
        dataEquiposPersonal,
        isLoading: isLoadingEquiposPersonal,
        isError: isErrorEquiposPersonal,
        error: errorEquiposPersonal,
        findOneStockPersonalEquipos
    } = useStockPersonalEquiposRepository()

    const getdataStockPersonalEquipos = async () => {
        try {
            await findOneStockPersonalEquipos({ StockPersonal: item })
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    useEffect(() => {
        getdataStockPersonalEquipos()
    }, [item])

    if (isLoadingEquiposPersonal) return <ViewLoading />
    if (isErrorEquiposPersonal) return <ViewError error={errorEquiposPersonal} />

    return (
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>Serie</th>
                    <th>Marca</th>
                    <th>Modelo</th>
                    <th style={{ textAlign: 'center' }}>Días</th>
                    <th>Fecha</th>
                    <th>Estado</th>
                </tr>
            </thead>
            <tbody>
                {
                    dataEquiposPersonal?.Equipos.map((item, index) => {
                        const hoy = new Date()
                        const fecha = new Date(item.Validado.Fecha)
                        const diferencia = hoy.getTime() - fecha.getTime()
                        const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24))

                        let color = ''

                        if (dias <= 5) {
                            color = '#90EE90' // verde claro
                        } else if (dias <= 20) {
                            color = '#FFD580' // naranja claro
                        } else {
                            color = '#FF7F7F' // rojo claro
                        }
                        return (
                            <tr key={index}>
                                <td>{item.Serie}</td>
                                <td>{item.Marca}</td>
                                <td>{item.Modelo}</td>
                                <td style={{ textAlign: 'center' }}>{dias}</td>
                                <td
                                    style={{ backgroundColor: color }}
                                >
                                    {fecha.toLocaleDateString('es-PE', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                </td>
                                <td>{item.Estado.Nombre}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}